import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { CheckCircle, Shield, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Hero background image configuration - easily replaceable
const HERO_BACKGROUND_IMAGE = "/lovable-uploads/80ee3cae-13df-4a97-a893-fcf454655abf.png";
interface HeroSectionProps {
  onScrollToSection: (sectionId: string) => void;
}
export const HeroSection: React.FC<HeroSectionProps> = ({
  onScrollToSection
}) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const heroImageSrc = "/lovable-uploads/59530d0f-33a8-445a-82f3-2063cc135491.png";
  
  const handleImageError = () => {
    console.log('Hero image failed to load:', heroImageSrc);
    setImageError(true);
  };
  
  const handleImageLoad = () => {
    console.log('Hero image loaded successfully:', heroImageSrc);
    setImageLoaded(true);
  };
  
  const heroFeatures = [{
    icon: <Zap className="w-5 h-5 text-blue-600" />,
    text: "Автоматизация бизнес-процессов"
  }, {
    icon: <CheckCircle className="w-5 h-5 text-blue-600" />,
    text: "Онлайн-доступ из любой точки"
  }, {
    icon: <Shield className="w-5 h-5 text-blue-600" />,
    text: "Контроль заказов, инвентаря и клиентов"
  }];
  return <section className="relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20">
      {/* Content */}
      <div className="relative z-10 flex py-4 sm:py-8 lg:py-12 my-0">
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-4">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-center gap-6 lg:gap-16">
            
            {/* Text Content - Mobile: Bottom, Desktop: Left */}
            <div className="text-left order-2 lg:order-1 w-full lg:flex-1 animate-fade-in mt-0 sm:mt-2 my-0 py-[2px] sm:py-[4px] px-[16px] pb-6 sm:pb-12">
              <h1 className="mb-4 sm:mb-8 text-slate-600 text-left mt-0 font-bold py-0 text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl leading-tight">
               Управление пунктами проката
              </h1>
              
              {/* Icon Features */}
              <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 text-left">
                {heroFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-left">
                    <div className="flex-shrink-0">{feature.icon}</div>
                    <span className="font-normal text-slate-500 my-0 py-[2px] text-sm sm:text-base">{feature.text}</span>
                  </div>
                ))}
              </div>

              <div className="text-left relative z-10">
                <Button size="lg" className="text-lg px-8 py-3 bg-blue-600 hover:bg-blue-700 transition-all duration-200 hover:scale-105 relative z-10" onClick={() => navigate('/register')}>
                  Попробовать бесплатно
                </Button>
              </div>
            </div>

            {/* Image Block - Mobile: Top, Desktop: Right */}
            <div className="flex justify-center lg:justify-end order-1 lg:order-2 w-full lg:flex-1 pt-0 sm:pt-2 lg:pt-0">
              <div className="w-full max-w-xl lg:max-w-full">
                <img 
                  alt="ARENDA PRO+ Система управления пунктами проката" 
                  className="w-full h-auto object-contain min-h-[300px] sm:min-h-[350px] md:min-h-[400px] lg:min-h-[500px] xl:min-h-[600px] max-h-[400px] sm:max-h-[450px] md:max-h-[500px] lg:max-h-[600px] xl:max-h-[700px] transition-opacity duration-300 ease-in-out"
                  src={heroImageSrc}
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  loading="eager"
                  style={{
                    opacity: imageLoaded ? 1 : 0
                  }}
                />
                {imageError && (
                  <div className="w-full h-64 bg-gray-100 rounded-lg flex items-center justify-center">
                    <div className="text-center text-gray-500">
                      <div className="text-4xl mb-2">📊</div>
                      <div className="text-sm">Система управления пунктами проката</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Blurred bottom edge */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent"></div>
    </section>;
};